{
  "adobeExperienceCloudNoOrgsSelect": "Seleziona un altro account organizzazione",
  "help": "Aiuto",
  "newAnnouncement": "È presente un nuovo annuncio",
  "notification": "Notifiche e annunci",
  "profile": "Profilo",
  "searchButton": "Cerca",
  "sidenavMenuCloseTooltip": "Chiudi menu",
  "sidenavMenuOpenTooltip": "Apri menu",
  "solutionSwitcher": "Passa a un’altra soluzione",
  "unread": "Notifiche non lette"
}
